const colors = {
  orange: "rgba(241, 143, 22, 0.8)",
  azure: "#26ABDF",
  white: "white",
  darkBlue: "#0053A0",
  grey: "#828282",
};

export default colors;
